import { toast } from 'react-toastify';

export const toastSuccess = (res) => {
  const message = res?.data?.message;
  return toast.success(message);
};

export const toastError = async (error) => {
  let message = error?.response?.data?.message || error?.message;

  if (error?.response?.data instanceof Blob) {
    try {
      const text = await error.response.data.text();
      const json = JSON.parse(text);
      message = json?.message || message;
    } catch (e) {
      message = error?.message;
    }
  }

  return toast.error(message);
};

export const toastWarning = (message) => {
  return toast.warn(message);
};

export const toastNotify = (message) => {
  return toast(message, { hideProgressBar: true });
};
